<!-- 1、模板结构 -->
<template>
  <div id="app" align="center">
    <h1>User Manager</h1>
    <table>
      <tr><th></th><th>用户名</th><th>姓名</th><th></th></tr>
      <tr v-for="user in users" v-bind:class="{fontColor:user.checked}">
        <td><input type="checkbox" v-model="user.checked"/></td>
        <td>{{user.username}}</td>
        <td>{{user.name}}</td>
        <td><button v-on:click="deleteUser(user)">删除</button></td>
      </tr>
      <tr><td colspan="4" align="center">
        <form>
          <input type="text" placeholder="请输入用户名" v-model="newUser.username"/>
          <input type="text" placeholder="请输入姓名" v-model="newUser.name"/>
          <input type="submit" value="提交" v-on:click="addUser"/>
        </form>
      </td></tr>
    </table>
  </div>
</template>

<!-- 2、JS处理 -->
<script>
export default {
  name: 'app',
  // 数组集合
  data(){
    return {
      users:[],
      newUser:{},
    };
  },
  // 初始化方法
  created:function(){
    this.$http.get("http://jsonplaceholder.typicode.com/users")
    .then(function(response){
      // console.log(response.data);
      this.users = response.data;
    });
  },
  methods:{
    deleteUser:function(user){
      var index = this.users.indexOf(user);
      this.users.splice(index,1);
    },
    addUser:function(event){
      event.preventDefault();
      var user = {
        username:this.newUser.username,
        name:this.newUser.name
      }
      this.users.push(user);
      this.newUser = {};
    },
  }
}
</script>

<!-- 2、样式处理 -->
<style scoped>
table,th,td{
  border:1px solid gray;
  border-collapse:collapse;
  padding:5px;
}
.fontColor{
  color:red;
}
</style>



// WEBPACK FOOTER //
// src/App.vue